import { api } from '../../lib/api';

export const dashboardApi = {
  summary: () => api.get('/dashboard/summary'),
  approvalsInbox: () => api.get('/approvals/inbox'),
};
